import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'

interface HeaderApiTokensReturn {
  config: ComputedRef<LinkBreadcrumbItem[]>
}

export const useHeaderApiTokens = (): HeaderApiTokensReturn => {
  const config = computed<LinkBreadcrumbItem[]>(() => [
    {
      id: 'api-tokens',
      text: 'API Tokens',
      to: AppRoute.ApiTokens,
      disabled: true,
    },
  ])

  return {
    config,
  }
}
